import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { AuthService } from '../../../../services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { ConfigService } from '../../../../services/config.service';

@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
})
export class NavigationComponent implements OnInit {
    @Input() appName = 'Account';
    @Input() showSecondBar = true;

    @Output() menuButtonClick = new EventEmitter();

    constructor(
        public auth: AuthService,
        public transLateService: TranslateService,
        public configService: ConfigService
    ) {}

    ngOnInit() {}

    menuButtonPressed() {
        this.menuButtonClick.emit();
    }
}
